import React from 'react';

import { Lock2 } from '@lyearn/icons';
import { cn } from '@lyearn/style';

import { buttonContainerStyles } from './styles';
import { ConfigType } from './types';

export const COMPLETE_CONFIG: ConfigType = {
  Container: {
    className: cn(
      'shadow-01 hover:shadow-02 w-full cursor-pointer xs:px-16 xs:py-20 xs:ps-20 xs:flex-col xs:items-stretch xs:justify-center xs:gap-20',
      buttonContainerStyles,
    ),
  },
  Label: {
    className: 'opacity-60',
    color: 'text-text-white',
    i18nKey: 'Course:Viewer.GreatJob',
  },
  Description: {
    color: 'text-text-white',
    i18nKey: 'Course:Viewer.YouveCompletedAllTheLessons',
  },
  Button: {
    className: 'ms-8 xs:ms-0 xs:w-full',
  },
  ActionsContainer: {
    className: 'xs:flex-col xs:gap-y-16',
  },
};

export const IncompleteConfig = (certificateTemplateId: string): ConfigType => ({
  Container: {
    className: 'bg-bg-secondary w-full',
  },
  Label: {
    color: 'text-text-placeholder',
    i18nKey: 'Course:Viewer.AlmostThere',
  },
  Description: {
    color: 'text-text-primary',
    i18nKey: certificateTemplateId
      ? 'Course:Viewer.CompleteAllLessonsToGetYourCertificate'
      : 'Course:Viewer.CompleteAllLessonsToFinishThisCourse',
  },
  Button: {
    className: 'bg-disabled-light ms-8',
    disabled: true,
    startIcon: <Lock2 className="h-20 w-20" fillColorToken="icon-secondary" />,
  },
});
